import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import { Button } from 'app/shared/ui';

import { trackAction } from '../../utils/tracking';

import {
  ErrorPageSt,
  ErrorImageSt,
  TitleSt,
  ErrorPageContainerSt,
} from './ErrorPage.css';

export class ErrorPage extends PureComponent {
  render() {
    const { errorCode, target, magazine } = this.props;

    const handleOnClick = () => {
      if (magazine) {
        trackAction(`${errorCode}_magazine_click`, {
          category: `${target}`,
          description: 'user clicks on main page magazine link from error page',
        });
        browserHistory.push('/magazine');
      } else {
        trackAction(`${errorCode}_home_click`, {
          category: `${target}`,
          description: 'user clicks on home link from error page',
        });
        browserHistory.push('/');
      }
    };

    return (
      <ErrorPageContainerSt>
        <ErrorPageSt>
          <ErrorImageSt
            src="/assets/pity_error.svg"
            alt="hey car error page"
            title="hey car error page"
          />

          <TitleSt>
            <h2>Ups, eine kleine Panne ist aufgetreten.</h2>
          </TitleSt>

          {magazine
            ? 'Die von dir angeforderte Seite konnte leider nicht gefunden werden. Klick auf den Link, um zurück zur Startseite des heycar Magazins zu gelangen und versuche es erneut.'
            : 'Klick auf den Link, um zurück zur Startseite zu gelangen und versuche es erneut.'}

          <Button variant="primary" onClick={handleOnClick}>
            Zurück zur Startseite
          </Button>
        </ErrorPageSt>
      </ErrorPageContainerSt>
    );
  }
}

ErrorPage.propTypes = {
  errorCode: PropTypes.number.isRequired,
  target: PropTypes.string,
  magazine: PropTypes.string,
};

ErrorPage.defaultProps = {
  target: 'error_page',
  magazine: '',
};
